import React from 'react';
import PropTypes from 'prop-types';

import Ripple from '../../utils/Ripple';
import Icon from '../../utils/Icon';

export default function AddButton({ onClick }) {
  return (
    <Ripple>
      <button
        className="btn btn-link extra-button"
        type="button"
        onClick={onClick}
      >
        <Icon name="plus2" />
      </button>
    </Ripple>
  );
}
AddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
